import { Component, Inject, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface CardImagePreviewData {
  imageUrl: string;
  title?: string;
  subtitle?: string;
  setName?: string;
  cardNumber?: string;
}

@Component({
  selector: 'app-card-image-preview-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './card-image-preview-modal.html',
  styleUrls: ['./card-image-preview-modal.scss']
})
export class CardImagePreviewModal {
  zoomScale: number = 1.0;
  rotationAngle: number = 0;

  constructor(
    private dialogRef: MatDialogRef<CardImagePreviewModal>,
    @Inject(MAT_DIALOG_DATA) public data: CardImagePreviewData
  ) {}

  zoomIn(): void {
    if (this.zoomScale < 3.5) {
      this.zoomScale = parseFloat((this.zoomScale + 0.25).toFixed(2));
    }
  }

  zoomOut(): void {
    if (this.zoomScale > 0.5) {
      this.zoomScale = parseFloat((this.zoomScale - 0.25).toFixed(2));
    }
  }

  resetZoom(): void {
    this.zoomScale = 1.0;
    this.rotationAngle = 0;
  }

  rotateLeft(): void {
    this.rotationAngle = (this.rotationAngle - 90 + 360) % 360;
  }

  rotateRight(): void {
    this.rotationAngle = (this.rotationAngle + 90) % 360;
  }

  close(): void {
    this.dialogRef.close();
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.close();
    } else if (event.key === '+' || event.key === '=') {
      this.zoomIn();
    } else if (event.key === '-') {
      this.zoomOut();
    } else if (event.key === 'r' || event.key === 'R') {
      this.resetZoom();
    }
  }
}
